import React from "react";
import Link from "next/link";
import UserAvatar from "@components/userComponents/UserAvatar";
import { useRouter } from "next/router";

export default function UserDetails({ post }) {
  const { user } = post;

  return (
    <div className="flex w-full items-start pt-12 px-8">
      <UserDetailsHeader user={user} />
    </div>
  );
}

// User Details Header Component
function UserDetailsHeader({ user }) {
  const router = useRouter();

  const handleAvatarClick = () => {
    router.push(`/user/${user.username}`);
  };
  return (
    <div className="flex w-full py-4 ">
      <div className="rounded-full cursor-pointer overflow-hidden">
        <UserAvatar
          handleClick={handleAvatarClick}
          user={user}
          active
          size="large"
        />
      </div>

      <div className="px-4 flex flex-col justify-center">
        <Link href={`/user/${user.username}`}>
          <div>
            <span className="text-xl cursor-pointer">{user.name}</span>
          </div>
        </Link>
        <Link href={`/user/${user.username}`}>
          <div>
            <span className="cursor-pointer">@{user.username}</span>
          </div>
        </Link>
      </div>
    </div>
  );
}
